<template>
  <b-container>
    <b-row>
      <b-col>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          @click.prevent="goback"
          variant="secondary"
          size="sm"
          >BACK</b-button
        >
      </b-col>
    </b-row>
    <loading
      :active.sync="isLoading"
      color="#5dbbda"
      loader="spinner"
      :is-full-page="fullPage"
      width:2
      height:2
    ></loading>
    <b-alert
      :show="showDismissibleAlertUnlock"
      dismissible
      @dismissed="showDismissibleAlertUnlock = false"
      :variant="variantUnlock"
      >{{ alertTextUnlock }}
    </b-alert>
    <div class="application-view container-fluid">
      <!-- Personal Details Section -->
      <div class="reg-form-box">
        <h5 class="reg-form-title text-primary">Personal Details</h5>
        <div class="reg-form-body">
          <div class="row">
            <div class="col-md-8">
              <div class="row mb-2">
                <div class="col-md-4 font-weight-bold">Board Name:</div>
                <div class="col-md-8">
                  {{ this.personalDetails.BoardName }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-4 font-weight-bold">Pool Type:</div>
                <div class="col-md-8">
                  {{ this.personalDetails.EventTitle }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-4 font-weight-bold">Application No:</div>
                <div class="col-md-8">
                  {{ this.personalDetails.ApplicationNo }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-4 font-weight-bold">Applicant Name:</div>
                <div class="col-md-8">
                  {{ this.personalDetails.FullName }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-4 font-weight-bold">Applicant Age:</div>
                <div class="col-md-8">
                  {{ this.personalDetails.ApplicantAge }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Print Page Break -->
      <div class="pagebreak"></div>

      <!-- Loading Spinner -->
      <div class="hide-print reg-form-box">
        <b-spinner
          variant="primary"
          label="Loading..."
          v-if="isLoading"
        ></b-spinner>
      </div>

      <!-- Approval Form Section -->
      <div class="reg-form-box">
        <Spinner size="32" message="Loading..." v-if="isLoading" />

        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
        >
          {{ alertText }}
        </b-alert>
      </div>
    </div>
    <div class="reg-form-box">
      <h5 class="reg-form-title text-primary">Documents Uploaded</h5>
      <div class="reg-form-body">
        <table class="table table-sm">
          <tr>
            <th>Document Type</th>
            <th>Link</th>
          </tr>
          <tr>
            <td>
              Police Verification Document{{
                personalDetails.PoliceVerification
              }}
            </td>
            <td>
              <a target="_blank" :href="getImgUrl(personalDetails.DocumentPath)"
                >View</a
              >
            </td>
          </tr>
           <tr>
            <td>
              Medical Document{{
                personalDetails.PoliceVerification
              }}
            </td>
            <td>
              <a target="_blank" :href="getImgUrl(personalDetails.DocumentPathMedical)"
                >View</a
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="reg-form-box">
      <div class="application-view container-fluid">
        <b-form @submit="onSubmit" class="hide-print">
          <!-- Approval Status -->
          <h5 class="reg-form-title text-primary">Approval Details</h5>
          <div class="reg-form-body">
            <b-row class="mb-3 justify-content-center">
              <b-col md="6">
                <b-form-group
                  label="Select Status"
                  label-for="ipDistrict"
                  label-cols-sm="2"
                  label-size="sm"
                >
                  <b-select
                    id="ipDistrict"
                    :options="ApprovalStatus"
                    value-field="ID"
                    text-field="StatusName"
                    v-model="form.ApplicationStatus"
                    required
                    size="sm"
                    class="form-control"
                    @change.native="checkReject"
                  ></b-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Remarks -->
            <b-row class="mb-3 justify-content-center">
              <b-col md="6">
                <b-form-group
                  label="Remarks"
                  label-for="RejectRemarks"
                  label-cols-sm="2"
                  label-size="sm"
                >
                  <b-form-textarea
                    id="RejectRemarks"
                    v-model="form.Remarks"
                    size="sm"
                    placeholder="Remarks"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Buttons -->
            <b-row class="mb-3 justify-content-center">
              <b-col cols="auto" class="d-flex gap-2">
                <b-button v-if="this.personalDetails.Status!=1"
                  type="submit"
                  variant="primary"
                  size="sm"
                  class="hide-print"
                >
                  Submit
                </b-button>
                &nbsp;
                <b-button
                  @click.prevent="goback"
                  variant="secondary"
                  size="sm"
                  class="hide-print"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import vueHtmlToPaper from "vue-html-to-paper";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import UserBForm from "@/components/UserBform.vue";
import Spinner from "vue-simple-spinner";

export default {
  components: { Spinner, DatePicker, UserBForm, Loading },
  props: ["ApplicationID"],
  data() {
    return {
      visible: true,
      showButton: true,
      showApproval: false,
      isLoading: false,
      fullPage: false,
      isReject: false,
      required: false,
      approveOptions: [
        { value: 1, text: "Pending" },
        { value: 2, text: "Approved" },
        { value: 3, text: "Rejected" },
      ],
      Caste: [],
      CasteID: "",
      PastLOI: false,
      appid: "",
      approvalStatus: {
        UserID: "",
        ApplicantPhotoStatus: null,
        ApplicantSignatureStatus: null,
        AdharCardStatus: null,
        PanCardStatus: null,
        RationCardStatus: null,
        CasteCertificateStatus: null,
        DegreeCertificateStatus: null,
        ExServiceManCertificateStatus: null,
        ExprienceCertificateStatus: null,
        DOBCertificateStatus: null,
        PoliceVerificationStatus: null,
        MedicalCertificateStatus: null,
        RecommendationLetterStatus: null,
        LegalHireNOCStatus: null,
        FinalDuesLetter: null,
        CourtOrder: null,
        DeceasedID: null,
        DeathCertificate: null,
        PFDeclaration: null,
        PoliceReceipt: null,
        NameChangeProof: null,
      },
      personalDetails: {},
      personalDetails1: {
        UserDetail: [{ RegistrationType: 2 }],
        ReligionCaste: [{ ReligionName: "" }],
      },
      docObj: {},
      user_id: "",
      docTbl: [],
      UserBFormID:"",
      form: {
        ApplicationStatus: 0,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ApplicationID: this.ApplicationID,
      },
      RoleID: 0,
      RegistrationID: "",
      ApprovalStatus1: [
        //{ StatusID: 1, Status: "Pending" },
        { StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Approve" },
        { StatusID: 3, Status: "Rejected" },
        { StatusID: 4, Status: "Resubmit" },
      ],
      ApprovalStatus: [],
      approvalRemarks: [],
      RejectRemarks: "",
      approvalFields: [
        "ApplicationStatus",
        "RejectionReason",
        "RejectRemarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat",
        },
        "ApproverName",
      ],
      RejectReasons: this.$store.getters.getRejectReason,
      alertText: "",
      variant: "success",
      isLoading: false,
      showDismissibleAlert: false,
      showDismissibleAlertUnlock: false,
      isLoadingUnlock: false,
      alertTextUnlock: "",
      variantUnlock: "success",
      uForm: {
        ApplicationID: this.ApplicationID,
        UserID: this.$store.getters.loggedUser.UserId,
        Remarks: "",
      },
    };
  },
  computed: {
    userBoard() {
      return this.$store.getters.getUserBoard;
    },
  },
  methods: {
    approveDoc(evt, docType) {
      if (evt.target.value == 0) {
        if (this.form.Remarks == "") {
          this.form.Remarks = "Error in Documents: " + docType;
        } else {
          this.form.Remarks += ", " + docType;
        }
      } else {
        if (this.form.Remarks == "Error in Documents: " + docType) {
          this.form.Remarks = "";
        } else {
          this.form.Remarks = this.form.Remarks.replace(", " + docType, "");
          this.form.Remarks = this.form.Remarks.replace(
            ": " + docType + ",",
            ":"
          );
        }
      }
    },
    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },

    previous() {
      this.unlock();
    },
    async unlock() {
      this.isLoadingUnlock = true;

      try {
        let dialog = await this.$dialog.prompt(
          {
            title: "Unlock Application",
            body: "Reason for Unlocking the application:",
          },
          {
            promptHelp: 'Type in the box below and click "[+:okText]"',
            okText: "Unlock Profile",
            cancelText: "Cancel",
            loader: false,
          }
        );

        if (dialog.data) {
          this.uForm.Remarks = dialog.data;
          this.$root.$emit("bv::show::modal", "confiramation_model");
        } else {
          this.isLoadingUnlock = false;
          this.$dialog
            .alert({
              title: "Alert",
              body: "Please Mention Reason.",
              confirmText: "Continue", // Set the label for the "Continue" button
            })
            .then(() => {
              // This function will be called when the user clicks "Continue"
              this.previous();
            });
          return false;
        }
      } catch (err) {
        this.isLoadingUnlock = false;
      }
    },
    goback() {
      this.$router.push({
        name: "PoliceverificationList",
        params: {},
      });
      
    },

    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit(evt) {
      evt.preventDefault();

      var payload = {
        BoardID: this.userBoard,
        Status: this.form.ApplicationStatus,
        UserBFormID: this.appid,
        Remark: this.form.Remarks,
        CreatedBy: this.user_id,
      };

      let promise = apis.UpdatePolVerDoc(payload);

      promise
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = "Application Status changed Successfully";
            this.variant = "success";

            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.showButton = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            //this.showDismissibleAlert = true;
            //this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          //this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    getImgUrl(pic) {
      if (pic) {
        return (
          "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
          this.personalDetails.UserID +
          "/" +
          pic
        );
      }
    },
  },

  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    this.user_id = this.$store.getters.loggedUser.UserId;
    this.RoleID = userinfo.RoleID;
    this.form.BoardID = this.userBoard;

    this.form.UserID = userinfo.UserId;
    this.isLoading = true;
    console.log(this.$route.params);
    //this.ApplicationID=this.$route.params.ApplicationID
    //alert('appid-',this.ApplicationID)
    var appid = this.$route.params.appid;
    this.appid = this.$route.params.appid;
    //alert(appid);
    let promiseSL = apis.ReadApproveStatus({ ID: this.ApplicationID });

    promiseSL
      .then((response) => {
        this.isLoading = false;
        if (response.status == 200) {
          this.ApprovalStatus = response.body;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
    this.isLoading = true;
    let promiseU = apis.readUserPoliceVerlist({ UserBFormID: appid }); //Personal Details

    promiseU
      .then((response) => {
        this.isLoading = false;
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.data.Data[0];
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  },
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 96%;
  margin-left: 2%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}
</style>